var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_725_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.820117 7.90941C0.819766 9.17955 1.15164 10.4197 1.7827 11.5129L0.759766 15.2478L4.58195 14.2456C5.63912 14.8211 6.8236 15.1226 8.02727 15.1227H8.03043C12.004 15.1227 15.2385 11.8893 15.2402 7.9151C15.241 5.9893 14.4917 4.1784 13.1303 2.81598C11.7692 1.45367 9.95893 0.703027 8.03014 0.702148C4.05613 0.702148 0.821816 3.93535 0.820176 7.90941",
    fill: "url(#paint0_linear_725_305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.562695 7.90719C0.562285 9.22303 0.906055 10.5076 1.55961 11.6398L0.5 15.5086L4.45924 14.4705C5.55014 15.0653 6.77838 15.3789 8.02818 15.3794H8.03141C12.1475 15.3794 15.4982 12.0297 15.5 7.91316C15.5007 5.91816 14.7245 4.04217 13.3145 2.63094C11.9043 1.21988 10.0293 0.442227 8.03141 0.441406C3.91461 0.441406 0.564336 3.79063 0.562695 7.90719ZM2.92057 11.4448L2.77273 11.2102C2.15129 10.2221 1.82328 9.08018 1.82375 7.90766C1.82504 4.48607 4.60965 1.70234 8.03375 1.70234C9.69195 1.70305 11.2503 2.34945 12.4224 3.52227C13.5945 4.6952 14.2394 6.25438 14.239 7.9127C14.2375 11.3343 11.4528 14.1184 8.03141 14.1184H8.02895C6.9149 14.1178 5.8223 13.8186 4.86945 13.2532L4.6427 13.1188L2.2932 13.7347L2.92057 11.4448Z",
    fill: "url(#paint1_linear_725_305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16465 4.78577C6.02484 4.47505 5.87771 4.46878 5.74477 4.46333C5.6359 4.45864 5.51145 4.45899 5.38711 4.45899C5.26266 4.45899 5.06045 4.50581 4.88953 4.69243C4.71844 4.87922 4.23633 5.33063 4.23633 6.24874C4.23633 7.16684 4.90506 8.05419 4.99828 8.17881C5.09162 8.30321 6.28928 10.2476 8.18607 10.9956C9.76248 11.6172 10.0833 11.4936 10.4254 11.4624C10.7676 11.4314 11.5296 11.0111 11.685 10.5754C11.8406 10.1397 11.8406 9.76618 11.7939 9.68813C11.7473 9.61038 11.6228 9.56368 11.4362 9.4704C11.2496 9.37712 10.3321 8.92559 10.161 8.86331C9.98994 8.80108 9.86555 8.77003 9.74109 8.95688C9.61664 9.14344 9.25928 9.56368 9.15035 9.68813C9.04154 9.81288 8.93262 9.8284 8.74605 9.73506C8.55932 9.64143 7.95832 9.44462 7.24529 8.80893C6.69053 8.31428 6.316 7.70344 6.20713 7.51659C6.09826 7.33003 6.19547 7.22889 6.28904 7.1359C6.37289 7.05229 6.47572 6.91799 6.56912 6.80907C6.66217 6.70008 6.69322 6.62233 6.75545 6.49788C6.81773 6.37331 6.78656 6.26432 6.73998 6.17098C6.69322 6.07764 6.33059 5.15473 6.16465 4.78577Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_725_305",
    x1: 724.782,
    y1: 1455.26,
    x2: 724.782,
    y2: 0.702148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_725_305",
    x1: 750.5,
    y1: 1507.16,
    x2: 750.5,
    y2: 0.441406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15.1172,
    fill: "white",
    transform: "translate(0.5 0.441406)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.6ddd8d9bf777b255d888470cf852cc39.svg";
export { ForwardRef as ReactComponent };